export default __webpack_public_path__ + "static/assets/62053bc7c949db9f583b96537b6c33ea.svg";